export const PENDO_API_KEY = '11227d4b-0f21-4d16-48d8-79043bbb1dbf';
//# sourceMappingURL=pendoApiKey.js.map